import { useEffect, useState } from "react";

const useDebounceQuery = (delay = 400) => {
  const [query, setQuery] = useState("");
  const [debounceQuery, setDebounceQuery] = useState(query);
  const [isTyping, setIsTyping] = useState(false);

  useEffect(() => {
    if (debounceQuery.length === 0) {
      setIsTyping(false);
      setQuery("");
      return;
    }
    setIsTyping(true);
    const timeout = setTimeout(() => {
      setQuery(debounceQuery);
      setIsTyping(false);
    }, delay);

    return () => clearTimeout(timeout);
  }, [debounceQuery]);

  return { query, debounceQuery, setDebounceQuery, isTyping };
};

export default useDebounceQuery;
